import { createContext } from 'utils/react-helpers';

const [ImplementProvider, useImplement] = createContext({
  name: 'ImplementContext',
});

export { ImplementProvider, useImplement };
